export { default } from '@material-ui/core/Slide';
